import Search from "antd/lib/input/Search";

export { Search };
